module.exports = __webpack_public_path__ + "media/images/weather/311_day-437e2fca7604e9ed63b24566eb26132e.png";